import { call, put, takeLatest } from 'typed-redux-saga';
import { logError } from '../../../../utils/log';
import { refreshUserInfo } from '../../../containers/UserLogin/saga';
import { getApiErrorMessage } from '../../../services/ApiClient';
import { updateApiCustomer } from '../../../services/customer';
import { myAccountNotifications } from '../notification';
import { userAccountPageActions } from './userAccount.slice';

function* submitCustomer(action: ReturnType<typeof userAccountPageActions.submitCustomer>) {
    try {
        yield* put(userAccountPageActions.setLoading(true));
        yield* call(updateApiCustomer, action.payload);
        yield* call(refreshUserInfo);
        yield* put(myAccountNotifications.updatedSuccessfully);
    }
    catch (error) {
        logError({
            error,
            target: 'UserAccountPage.submitCustomer',
        });
        const message = getApiErrorMessage(error);
        yield* put(myAccountNotifications.unknownError(message));
    }
    finally {
        yield* put(userAccountPageActions.setLoading(false));
    }
}

export function* submitCustomerSaga() {
    yield* takeLatest(userAccountPageActions.submitCustomer, submitCustomer);
}
